/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DialogService, NotificationService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { arrayify, getFileExtension } from '@gh/core-util';
import { of$ } from '@gh/rx';
import { filter$, first$, switchMap$, tap$ } from '@gh/rx/operators';
import { flatMap } from 'lodash';

@Component({
  selector: 'gh-input-file',
  template: require('./input-file.component.html'),
  styles: [require('./input-file.component.scss')],
})
export class InputFileComponent {
  @Input() disabled: boolean = false;
  @Input() accept: string = '';
  @Input() skin: string = '';
  @Input() title: string;
  @Input() errorInBalloon: boolean;
  @Input() flexCrossCenter: boolean;

  // fixme: use default invalid type message
  @Input() invalidTypeMessage: string = 'msg_import_prices_file_invalid';

  @Output() update: EventEmitter<any> = new EventEmitter();

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  file: Maybe<File>;

  private _extensions: string[] = [];

  constructor(private notificationService: NotificationService,
              private dialogService: DialogService) {

  }

  @Input()
  set extensions(extensions: string | string[]) {
    this._extensions = flatMap(arrayify(extensions), (extension: string) => extension.split(/\s*,\s*/g))
      .map((ext) => ext.toLowerCase());
  }

  get fileName(): string {
    return this.file && this.file.name || '';
  }

  get isFileSelected(): boolean {
    return Boolean(this.file);
  }

  /**
   * FIXME: MUST bew used in change event to control file exist or not
   * @param file
   */
  onSelect(file?: File): void {
    if (file && (this.isFileHasValidMimeType(file) || this.isFileHasValidExtension(file))) {
      this.file = file;
      this.update.emit(this.file);
    } else {
      if (this.errorInBalloon) {
        this.notificationService.error(this.invalidTypeMessage);
      } else {
        this.dialogService.warning(this.invalidTypeMessage, { correctType: this.accept });
      }
    }
    // tslint:disable-next-line:no-null-keyword
    this.fileInput.nativeElement.value = null;
  }

  onClick($event: Event): void {
    this.file = void 0;
    this.update.emit(void 0);
    this.clear();
  }

  clear(): void {
    this.file = void 0;
    this.fileInput.nativeElement.value = null; // tslint:disable-line:no-null-keyword
  }

  private isFileHasValidMimeType(file: File): boolean {
    return !this.accept || file.type === this.accept;
  }

  private isFileHasValidExtension(file: File): boolean {
    const extension = getFileExtension(file.name).toLowerCase();
    return !this._extensions.length || this._extensions.includes(extension);
  }
}
